export default __webpack_public_path__ + "static/media/aymo_new.9af730bd.png";